import { useGetContactInfo } from "api/initial/useGetContactInfo";
import { useGetContractIdData } from "providers/ContractIdProvider";
import { Avatar } from "./Avatar";

export interface SelectedContactNameProps {
  onClick?: () => void;
}

export const SelectedContactName = ({ onClick }: SelectedContactNameProps) => {
  const { selectedContact } = useGetContractIdData();
  const { data: contactData } = useGetContactInfo();
  if (selectedContact && contactData) {
    return <button onClick={onClick} className="uppercase truncate">
        {selectedContact?.userName ?? ""}
    </button>
  } else {
    return <Avatar backgroundColor={"bg-white"} initials={""} />;
  }
};
